<template>
  <v-select
    id="consultant-select"
    v-model="filter.usuarioId"
    item-text="nome"
    item-name="usuarioId"
    item-value="usuarioId"
    :items="users"
    :label="consultorLabel"
    :placeholder="consultorLabel"
    clearable
  >
    <template slot="no-data"> Nenhum usuário retornado </template>
  </v-select>
</template>

<script>
import { userAPI } from "./UserAPI";

export default {
  name: "AppConsultantCombobox",
  props: ["filter"],
  mounted() {
    this.loadConsultant();

    if (!this.isAT || this.$store.state.uf === "MA") {
      this.consultorLabel = "Responsável";
    }
  },
  methods: {
    loadConsultant() {
      userAPI
        .listConsultant()
        .then((resp) => {
          this.users = resp.data;
        })
        .catch((resp) => {
          this.$notification.error("Erro ao obter usuários");
        });
    },
  },
  data() {
    return {
      users: [],
      consultorLabel: "Consultor",
    };
  },
};
</script>
